import { FIELD_TYPES } from "constants/template-field-type";
import SharedAdvancedFieldsConfig from "segments/desktop/shared-advanced-fields-config";

export default {
  type: FIELD_TYPES.NESTED,
  label: "",
  fields: {
    ...SharedAdvancedFieldsConfig,
    progressbarColor: {
      type: FIELD_TYPES.COLOR_PICKER,
      label: "Progressbar color"
    },
    tabsMargin: {
      type: FIELD_TYPES.TEXT,
      label: "Tabs margin (default 40px)"
    },
    transitionTime: {
      type: FIELD_TYPES.TEXT,
      label: "Transition time (ms) between slides - also set auto play"
    }
  }
};
